<template>
  <STooltip :tooltip="tr('client.company_card.badges_premium_partner_tooltip')">
    <div class="s-company-badge s-company-badge--premium-partner">
      <SCompanyBadgeStyles />
      {{ tr("client.company_card.badges_premium_partner") }}
    </div>
  </STooltip>
</template>

<script setup lang="ts">
import { STooltip } from "@solvari/common-fe";
import { useI18nCompanyCard } from "@solvari/translations";

import SCompanyBadgeStyles from "./SCompanyBadgeStyles.vue";

const { tr } = useI18nCompanyCard();
</script>
